"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.expectedApiErrors = void 0;
const API_ERRORS_ACCURX_WEB = [
    {
        /**
         * Feature: Settings - change password
         * @url https://web.accurx.com/practices/settings/password
         * @description When changing password users give an incorrect old password
         */
        api: "/api/account/ChangePassword",
        code: 400,
        messages: ["Incorrect password"],
    },
    {
        /**
         * Feature: Batch messaging - upload list of patients
         * @url https://web.dev.accurx.com/practices/3/batch-messaging-upload
         * @description When user tries to upload a bad CSV
         */
        api: "/api/patientMessaging/batchMessaging/:practiceId/upload",
        code: 400,
        messages: [
            "we can't find a column that we need",
            "we found duplicate columns that we need",
            "Your CSV was not uploaded due to the following problems",
            "The uploaded file is empty",
        ],
    },
    {
        /**
         * Feature: Accubook - upload list of patients
         * @url https://web.dev.accurx.com/practices/3/vaccine-invites-upload-and-review
         * @description When user tries to upload a bad CSV
         */
        api: "/api/recall/practices/:orgId/recallinvites/upload",
        code: 400,
        messages: [
            "Please check that you have the following columns and try again",
            "List contains a duplicate on",
            "Bad data on",
            "Please make sure your list contains 1 or more patients",
            "Please make sure your list contains no more than 500 patients and try again",
            "Please upload a file which supplies the full year",
            "Your patients haven't been uploaded as there are no available slots for them to book into. Please talk to your nominated coordinating site about getting more set up.",
        ],
    },
    {
        /**
         * Feature: Accubook - Publishing a session
         * @url https://web.dev.accurx.com/organisations/3/accubook/manage-clinics
         * @description When user to publish a session that overlap with another
         */
        api: "/api/recall/Practices/:practiceId/RecallSetups/:siteSetupId/Sessions/:sessionId/Publish",
        code: 400,
        messages: [
            "Session overlaps with an existing session",
            "We could not save this clinic as the start time is in the past.",
            "Invalid length for location text",
        ],
    },
    {
        /**
         * Feature: Accubook - Deleting a session
         * @url https://web.dev.accurx.com/organisations/3/accubook/manage-clinics
         * @description When a user tries to delete a session with still active bookings
         */
        api: "/api/recall/Practices/:practiceId/RecallSetups/:siteSetupId/Sessions/:sessionId",
        code: 403,
        messages: [
            "Any patient bookings for the session must be cancelled before it can be delete",
        ],
    },
    {
        /**
         * Feature: Accubook - Inviting patients to booster
         * @url https://web.dev.accurx.com/practices/3/vaccine-invites-compose-second
         * @description When user upload a invalid patient list or message is too long
         */
        api: "/api/recall/practices/:orgId/recallinvites/:inviteBatchId/inviteToBooster/:inviteId",
        code: 400,
        messages: ["Already invited for booster", "Invite message too long"],
    },
    {
        /**
         * Feature: Custom Floreys - Updating name and questions
         * @url https://web.accurx.com/practices/:orgId/questionnaire-builder/name-and-questions/:questionnaireId
         * @description When two users edit the same resource, the second one will get an error message asking them to refresh
         */
        api: "/api/floreybuilder/questionnaires/:questionnaireId",
        code: 409,
        messages: [
            "Another user has edited that resource, please refresh and try again",
        ],
    },
];
const API_ERRORS_FLOREY = [
    {
        /**
         * TODO we are currently ignoring all 400 on this api. This is not safe.
         * Backend need to send us back a message so that we ignore this specific case
         *
         * Feature: Patient triage - confirm mobile with 2fa
         * @url https://florey.dev.accurx.com/p/A29392/confirm-2-FA
         * @description When user submit an incorrect 2FA code
         */
        api: "/api/CheckMobile/verify",
        code: 400,
        messages: [],
    },
    {
        /**
         * Feature: Appointment Cancellation - User cancelling appointment via appointment reminder message
         * @url https://accurx.nhs.uk/a/{bookingId}
         * @description When user tries to cancel the appointment closer to the appoinment time
         */
        api: "/api/appointmentpatient/reminder/:urlId/cancel",
        code: 400,
        messages: [
            "It is too late to update this appointment here. Please contact your healthcare team.",
        ],
    },
];
const API_ERRORS_PATIENT = [
    {
        api: "/api/patient/conversation/:conversationId/authenticate",
        code: 403,
        messages: [
            "You have reached the maximum number of attempts to input your date of birth",
        ],
    },
    {
        api: "/api/patient/conversation/:conversationUrlId/appointment/:appointmentUrlId",
        code: 409,
        messages: [
            "Redirect to self-book requested for non-open booking request",
        ],
    },
    {
        api: "/api/patient/conversation/:conversationId/send",
        code: 409,
        messages: ["Enrolment already replied to"],
    },
];
exports.expectedApiErrors = [
    ...API_ERRORS_ACCURX_WEB,
    ...API_ERRORS_FLOREY,
    ...API_ERRORS_PATIENT,
];
//# sourceMappingURL=ExpectedApiResponses.js.map